import React from 'react'
import {useIntl} from 'react-intl'

export type SyncWidgetStatus = 'polling' | 'completed' | 'skipped' | 'error'

interface SyncAutomationWidgetProps {
  status: SyncWidgetStatus
  appliedRules: number[]
  totalRules: number
  onClose: () => void
}

export const SyncAutomationWidget: React.FC<SyncAutomationWidgetProps> = ({
  status,
  appliedRules,
  totalRules,
  onClose,
}) => {
  const intl = useIntl()
  const appliedCount = appliedRules.length
  const progressPercent = totalRules > 0 ? (appliedCount / totalRules) * 100 : 0

  return (
    <div className='gori-popup-sync-automation-rules position-fixed rounded-2 border border-gray-300 p-4'>
      <div className='d-flex align-items-center justify-content-between mb-3'>
        <div className='d-flex align-items-center gap-2'>
          <span className='text-gray-700 fw-bold ms-1'>
            {intl.formatMessage({id: 'SYNCING_AUTOMATION_RULES'})}
          </span>
        </div>
      </div>

      {status === 'polling' && (
        <>
          <div className='small mb-1 text-muted'>
            {intl.formatMessage(
              {id: 'SYNC_AUTOMATION_RULES_APPLIED'},
              {applied: appliedCount, total: totalRules}
            )}
          </div>
          <div className='progress'>
            <div className='progress-bar' style={{width: `${progressPercent}%`}}></div>
          </div>
        </>
      )}

      {status === 'completed' && (
        <>
          <div className='small mb-1 text-muted'>
            {intl.formatMessage(
              {id: 'SYNC_AUTOMATION_SUCCESS'},
              {applied: appliedCount, total: totalRules}
            )}
          </div>
          <div className='progress'>
            <div className='progress-bar' style={{width: '100%'}}></div>
          </div>
          <div className='d-flex fw-bolder mt-5 mb-1 align-items-center'>
            <span className='btn-retry cursor-pointer' onClick={onClose}>
              {intl.formatMessage({id: 'CLOSE'})}
            </span>
          </div>
        </>
      )}

      {status === 'skipped' && (
        <>
          <div className='small mb-1 text-muted'>
            {intl.formatMessage({id: 'SYNC_AUTOMATION_NO_ORDERS_MATCHED'})}
          </div>
          <div className='d-flex fw-bolder mt-5 mb-1 align-items-center'>
            <span className='btn-retry cursor-pointer' onClick={onClose}>
              {intl.formatMessage({id: 'CLOSE'})}
            </span>
          </div>
        </>
      )}

      {status === 'error' && (
        <>
          <div className='small mb-1 text-danger'>
            {intl.formatMessage({id: 'SYNC_AUTOMATION_ERROR'})}
          </div>
          <div className='d-flex fw-bolder mt-5 mb-1 align-items-center'>
            <span className='btn-retry cursor-pointer' onClick={onClose}>
              {intl.formatMessage({id: 'CLOSE'})}
            </span>
          </div>
        </>
      )}
    </div>
  )
}
